
if (!customElements.get('quick-add-to-cart-button')) {
  class TG_QuickAddToCartButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.delegateElement = new themegoal.libs.Delegate(this);
      this.delegateElement.on('click', '[data-action="quick-add-to-cart"]', this._addToCart.bind(this));
    }

    disconnectedCallback(){
      if(this.delegateElement)this.delegateElement.destroy();
    }

    _addToCart(event) {
      var _this = this;
      event.preventDefault();

      var formElement = this.querySelector('form.ProductQuickAddToCardForm');
      var addToCartButton = this.querySelector('.ProductQuickAddToCardForm__AddToCart');

      if (!formElement || !addToCartButton || addToCartButton.disabled) return;

      if (!formElement.checkValidity()) {
        formElement.reportValidity();
        return;
      }

      var loadingState = window.RPCartLoading
        ? window.RPCartLoading.beginButton(addToCartButton, 'Adding\u2026')
        : null;

      if (!loadingState) {
        addToCartButton.setAttribute('disabled', 'disabled');
        addToCartButton.setAttribute('aria-busy', 'true');
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
      }

      function finishLoading() {
        if (loadingState && window.RPCartLoading) {
          window.RPCartLoading.end(loadingState);
        } else {
          addToCartButton.removeAttribute('disabled');
          addToCartButton.removeAttribute('aria-busy');
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        }
      }

      fetch(window.routes.cartAddUrl + '.js', {
        body: JSON.stringify(themegoal.components.Form.serialize(formElement)),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' 
        }
      }).then(function (response) {
        return response.json().then(function (content) {
          if (!response.ok) {
            var cartError = new Error(content.description || content.message || 'Unable to add this product to the cart.');
            cartError.cartContent = content;
            throw cartError;
          }

          if (window.theme.cartType == 'page' && !_this.hasAttribute('data-keep-on-page')) {
            window.location.href = window.routes.cartUrl;
            return;
          }

          return new Promise(function (resolve) {
            var completed = false;
            var completionTimeout;
            var onComplete = function () {
              if (completed) return;
              completed = true;
              window.clearTimeout(completionTimeout);
              resolve();
            };

            completionTimeout = window.setTimeout(onComplete, 10000);

            _this.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: _this.currentVariant,
                quantity: parseInt(_this.querySelector('[name="quantity"]').value),
                cartItemKey: content.key,
                onComplete: onComplete
              }
            }));

            if (window.theme.cartType != 'drawer' || !document.querySelector('section-cart-drawer')) {
              onComplete();
            }
          });
        });
      }).catch(function (error) {
        var content = error.cartContent || {};
        var description = typeof content.description === 'object'
          ? content.message
          : content.description;
        var errorMessageElement = document.createElement('div');
        errorMessageElement.className = 'Alert Alert--danger';
        errorMessageElement.setAttribute('role', 'alert');
        errorMessageElement.textContent = description || error.message || 'Unable to add this product to the cart.';
        addToCartButton.insertAdjacentElement('beforeBegin', errorMessageElement);
        setTimeout(function () {
          errorMessageElement.remove();
        }, 8000);
      }).finally(finishLoading);
    }
  }
  
  customElements.define('quick-add-to-cart-button', TG_QuickAddToCartButton);
}
